export const BILLING = {
  SET_IS_ACTIVE: 'SET_IS_ACTIVE_BILLING',
  SET_SERVICE_DATA: 'SET_SERVICE_DATA',
  SET_BILLING_PERMISSIONS: 'SET_BILLING_PERMISSIONS',
  SET_BILLING_PERMISSIONS_CURRENT: 'SET_BILLING_PERMISSIONS_CURRENT',
  SET_BILLING_EVENT: 'SET_BILLING_EVENT',
  SET_REFERRAL_DATA: 'SET_REFERRAL_DATA',
  SET_SHOULD_CLOSE_PAYMENT_FORM: 'SET_SHOULD_CLOSE_PAYMENT_FORM',
}
